module.exports = __webpack_public_path__ + "assets/4fd753f5dcb777a3ca1a132d5f4991fc.mp3";